var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 331,
    viewBox: "0 0 368 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.3V54.5L92 96.9L184 139.3L237.5 114.6C266.9 101.1 291.6 89.7 292.5 89.4C293.8 88.8 294 96.2 294 160.9V233H318.5H343V122.4C343 61.6 342.7 12.1 342.3 12.3C341.8 12.5 306.1 29 262.8 48.9L184.1 85.2L108.3 50.2C66.6 30.9 25.2 11.8 16.3 7.70001L0 0.100021V27.3Z",
    fill: "#42A8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 225.9V331H196.5H368V306.5V282L221.3 281.8L74.5 281.5L74.2 212.5L74 143.4L50.2 132.5C37.2 126.6 26.2 121.5 25.8 121.3C25.3 121.1 25 168.2 25 225.9Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fd83b907b0aca7c9a277322872cd5243.svg";
export { ForwardRef as ReactComponent };